module.exports = __webpack_public_path__ + "img/newsImg11-18.823d0f1b.png";